const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/ImageClientLoader/ImageClientLoader.tsx';
import { getImageFileName } from 'App/utils/clientSetupManager';
import { theme } from 'App/utils/clientSetupManager';
import { css, cx } from '@emotion/css';

interface Props {
    src: string;
    className?: string;
    style?: string;
}

const backgroundImageClass = css`
    background: no-repeat center/cover;
    ${theme?.custom?.imageClientAlign || ''};
`;

// btw: by default: images are loaded once they are needed
export const ImageClientLoader = (props: Props) => {
    return (
        <div
            className={cx(props.className, backgroundImageClass)}
            style={{ backgroundImage: `url(${getImageFileName(props.src)})` }}
        />
    );
};

export const ImageInplaceLoader = (props: Props) => {
    return <img className={cx(props.className)} src={getImageFileName(props.src)} />;
};
